import { Box, styled } from '@mui/material'

/**
 * FullWidthSectionSt - Breaks out of parent width restrictions using viewport width
 * and calculated margins to compensate for parent positioning.
 * This allows the section to take full viewport width while being inside a constrained parent.
 * 
 * Uses a technique that prevents horizontal scroll:
 * - Uses viewport width with left/right positioning
 * - The inner container handles centering with max-width
 */
export const FullWidthSectionSt = styled(Box)({
  boxSizing: 'border-box',
  position: 'relative',
  width: '100vw',
  marginLeft: 'calc(50% - 50vw)',
  marginRight: 'calc(50% - 50vw)',
})

/**
 * FullWidthSectionInner - Inner container that maintains the same max-width (800px)
 * and centering behavior as PageWrapper, so content appears exactly the same visually.
 * This ensures the visual appearance remains unchanged while allowing full-width backgrounds.
 */
export const FullWidthSectionInner = styled(Box)({
  boxSizing: 'border-box',
  position: 'relative',
  marginLeft: 'auto',
  marginRight: 'auto',
  width: '100%',
  maxWidth: '800px',
})

